module.exports = __webpack_public_path__ + "files/gras.aaca37f3076c582edbdc4faaddbf3f27.pdf";